import ProgressBar from "@ch/components/ProgressBar/ProgressBar";
import theme from "@ch/helpers/utils/theme";
import type { FC } from "react";

interface KemSessionProgressBarProps {
  progress?: number;
  accessibilityLabel: string;
  className?: string;
}

const KemSessionProgressBar: FC<KemSessionProgressBarProps> = ({
  progress,
  accessibilityLabel,
  className = "",
}) => {
  if (progress === undefined) {
    return null;
  }

  return (
    <ProgressBar
      accessibilityLabel={accessibilityLabel}
      className={className}
      height={4}
      progress={progress}
      progressColor={theme.colors.green.DEFAULT}
    />
  );
};

export default KemSessionProgressBar;
